import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Science as ScienceIcon, Edit as EditIcon } from '@mui/icons-material';

function ExampleDataBanner({ onDismiss }) {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                px: 2,
                py: 1,
                mb: 1.5,
                borderRadius: 1,
                backgroundColor: 'rgba(144, 202, 249, 0.08)',
                border: '1px solid rgba(144, 202, 249, 0.25)',
                flexWrap: 'wrap',
            }}
        >
            <ScienceIcon sx={{ color: '#90caf9', fontSize: 18, flexShrink: 0 }} />
            <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.75)', flex: 1 }}>
                <strong style={{ color: '#90caf9' }}>Example data loaded</strong> — 50 shaft diameter measurements showing
                a capable process. Submit to see full analysis, or clear and enter your own data.
            </Typography>
            <Button
                size="small"
                startIcon={<EditIcon sx={{ fontSize: 14 }} />}
                onClick={onDismiss}
                sx={{
                    fontSize: '0.7rem',
                    color: 'rgba(255,255,255,0.6)',
                    border: '1px solid rgba(255,255,255,0.2)',
                    py: 0.25,
                    px: 1,
                    textTransform: 'none',
                    whiteSpace: 'nowrap',
                    '&:hover': { borderColor: 'rgba(255,255,255,0.4)', color: '#fff' },
                }}
            >
                Clear &amp; enter my data
            </Button>
        </Box>
    );
}

export default ExampleDataBanner;
